<template>
  <div class="product-base">
    <product-search></product-search>
    <rl-bg>
      <div class="product-enter">
        <product-classify />
        <product-banner :ui-banner="Banner" />
        <product-right :ui-right="TopRight" />
      </div>
      <div class="product-detail">
        <product-bottom :bottom-left="BottomLeft" />
      </div>
    </rl-bg>
  </div>
</template>
<script>
  import ProductBanner from "@/views/Product/home/banner";
  import ProductSearch from "@/views/Product/home/ProductSearch";
  import ProductClassify from "@/views/Product/home/classify";
  import ProductRight from "@/views/Product/home/right";
  import ProductBottom from "@/views/Product/home/bottom";
  import RlBg from "@/components/bg";
  export default {
    name: "ProductEnter",
    components: {
      RlBg,
      ProductBottom,
      ProductRight,
      ProductClassify,
      ProductBanner,
      ProductSearch
    },
    data(){
      return{
        Banner:{},
        TopRight:{},
        BottomRight:{},
        BottomLeft:{}
      }
    },
    created() {
      this.GetData()
      document.title='瑞普商城'
    },
    methods:{
      async GetData(){
        this.$axios.get('/api/photo/getBuildStore').then(res=>{
          this.Banner=res.data.data[0];
          this.TopRight=res.data.data[1];
          this.BottomRight=res.data.data[2];
          this.BottomLeft=res.data.data[3];
        })
      }
    }
  }
</script>

<style lang="less"  scoped>
  .product-base{
    box-sizing: border-box;
    width: 100%;
    .product-enter{
      width: 100%;
      display: flex;
      margin-top: 15px;
    }
    .product-detail {
      display: flex;
      justify-content: center;
      margin-top: 20px;
      margin-bottom: 40px;
    }
  }
</style>